<div class="mb-3">
  <label *ngIf="hasLabel">{{ label | translate }}</label>
  <input
    class="form-control"
    [formControl]="field"
    [placeholder]="placeholder | translate"
    [required]="required"
    [disabled]="disabled"
    currencyMask
    [options]="options"
    [attr.id]="resolvedInputId"
  />
  <div *ngIf="hasHint" class="form-text">{{ hint | translate }}</div>
  <div *ngIf="isPending" class="form-text">{{ 'label.pending' | translate }}</div>
  <div *ngIf="showError" class="form-text text-danger">{{ error | translate }}</div>
</div>
